















import Vue from 'vue'
import HomeNew from '@/UI/Home/HomeNew.vue'
export default Vue.extend({
  name: 'HomeLayout',
  components: { HomeNew },
  data () {
    return {
      continuar: false
    }
  },
  props:
  {
    novas: {
      type: Array,
      required: true
    }
  }
})
